import { isAuth0Flow } from '../../authProvider';

export const requirements = {};
export const verifier = () => {
  return !isAuth0Flow();
};
